const routes = {
    notFound: () => "*",
    serviceNotActive: () => "/not-active",
    home: () => "/",
    fulfilmentDetail: () => `/fulfilment-detail`,
};

export default routes;
